<template>
    <div class="bg overflow_hide">
        <div class="soft-title">{{this.$route.query.softwareName}}</div>
        <div class="box overflow_hide" >
            <div class="soft-box overflow_hide">
                <!--:style="'height:'+bodyWidth/10+'px;line-height:'+bodyWidth/10+'px'"-->
                <div v-for="m in moduleList" :key="m.id"
                     class="soft overflow_hide">
                    <div class="name">{{m.moduleName}}</div>
                    <ul class="overflow_hide">
                        <li v-for="c in m.children" :key="c.id" @click="openModule(c)">{{c.moduleName}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Software",
        data(){
            return{
                moduleList:[],
            }
        },
        created() {
            this.getModule();

            //
        },
        computed:{
        },
        methods:{
            openModule(w){
                window.open(this.serverIp+"/upload/webgl/"+w.moduleUrl);
            },
            getModule(){
                this.$json("/SoftwareModule/pageSoftwareModule","POST",{andModel:{softwareId:this.$route.params.id,flag:1}}).then(res=>{
                    console.log(res.data)
                    this.moduleList = res.data;
                    //this.tableTotalData = res.total;
                });
            }
        },
        mounted() {
            let a  = document.querySelector(".soft-box");
            const height = document.body.clientHeight;
            a.style.cssText="position:absolute;top:"+(height-180)/2+"px;"
        },
        watch:{
        }
    }
</script>

<style scoped lang="less">
    .soft-title{
        margin-top:50px;
        font-size:30px;
        height:100px;
        line-height: 100px;
        //background: linear-gradient(#a1e5fc , #58d1f7,#a1e5fc);
        display: inline-block;
        padding: 0 50px;
    }
    .bg{
        width:100%;
        height:100%;
        background: url("../../../static/img/software/bg.png") center no-repeat;
        background-size: 100%;
    }
    .box{
        //height:200px;
        position: absolute;
        overflow: hidden;
        top:0;
        right: 0;
        bottom: 0;
        left:0;
        margin: auto;}
    .soft-box{
        display: flex;
        justify-content: center;
        width: 100%;
        .soft{
            width:10%;
            margin:0 2%;
            text-align: center;
            overflow: hidden;
            .name{
                background: url("../../../static/img/software/btn.png") center no-repeat;
                background-size: 100%;
                box-sizing: border-box;
                height:100px;
                line-height:100px;
                cursor: pointer;
                font-size:1.2rem;
                white-space: nowrap;
                font-family: "Microsoft YaHei";
                color:#fff;
            }
            ul:before{
                height: 0;
            }
            ul{
                width: 96%;
                display: none;
                overflow:auto;
                li{
                    cursor: pointer;
                    user-select: none;
                    height:40px;
                    line-height: 40px;
                    //background: linear-gradient(#ceeafc , #70c2f8);
                    background-color: #74c5f8;
                    color:#28292b;
                    font-size:14px;
                    &:hover{
                        color:#fff;
                    }
                }
                li:not(:last-child){
                    border-bottom: 1px solid #fff;
                }
            }
            &:hover ul{
                display: inline-block;
                height:auto;
                //transition: 0.2s;
            }
        }
 }

</style>
